import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateCountryEdit = {
  countryEdit: { data: null, loading: false, error: null },
};

export const countryEdit = createAsyncThunk('user/countryEdit', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .post(`/country/update/${data.countryId}`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCountryEdit = {
  [countryEdit.pending]: (state) => {
    state.countryEdit.loading = true;
  },
  [countryEdit.fulfilled]: (state, action) => {
    state.countryEdit.loading = false;
    state.countryEdit.data = action.payload;
    state.countryEdit.error = null;
  },
  [countryEdit.rejected]: (state, action) => {
    state.countryEdit.data = null;
    state.countryEdit.loading = false;
    state.countryEdit.error = action.payload;
  },
};
